// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchLanguagesTable, fetchLanguages, fetchLanguageById, addLanguage, updateLanguage, removeLanguage } from "../../api/languageApi";


// Async thunks for language operations

export const getLanguages = createAsyncThunk(
  "language/getLanguages",
  async ({ page, limit }: { page: number; limit: number }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchLanguagesTable(page, limit);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getLanguageById = createAsyncThunk(
  "language/getLanguageById",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchLanguageById(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createLanguage = createAsyncThunk(
  "language/createLanguage",
  async (newLanguage: { folder_name: string; language_code: string; language: string; content?: File }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addLanguage(newLanguage);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editLanguage = createAsyncThunk(
  "language/editLanguage",
  async (
    { id, updatedLanguage }: { id: string; updatedLanguage: { folder_name: string; language_code: string; language: string; content?: File } },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await updateLanguage(id, updatedLanguage);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteLanguage = createAsyncThunk(
  "language/deleteLanguage",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await removeLanguage(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Language Slice

const languageSlice = createSlice({
  name: "language",
  initialState: {
    languages: [] as any[],
    language: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all languages
      .addCase(getLanguages.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.languages = action.payload;
      })
      .addCase(getLanguages.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Get language by ID
      .addCase(getLanguageById.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.language = action.payload;
      })
      .addCase(getLanguageById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Create language
      .addCase(createLanguage.fulfilled, (state, action: PayloadAction<any>) => {
        if (Array.isArray(action.payload)) {
          state.languages.push(action.payload);
          state.status = true;
          state.msg = "Language created successfully.";
        } else {
          console.log('language not an array');
        }
      })

      // Edit language
      .addCase(editLanguage.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if (Array.isArray(state.languages)) {
          const index = state.languages.findIndex((language) => language.id === id);
          if (index !== -1) {
            state.languages[index] = data;
          }
          state.status = true;
          state.msg = "Language updated successfully.";
        } else {
          console.log('language not an array');
        }
      })

      // Delete language
      .addCase(deleteLanguage.fulfilled, (state, action: PayloadAction<string>) => {
        if (Array.isArray(state.languages)) {
          state.languages = state.languages.filter((language) => language.id !== action.payload);
          state.status = true;
          state.msg = "Language deleted successfully.";
        } else {
          console.log('language not an array');
        }
      });
  },
});

export const { resetStatus } = languageSlice.actions;
export default languageSlice.reducer;